module.exports = __webpack_public_path__ + "img/v51.0b18f029.jpg";